// What the tenant list shows of each tenant's licences (anima_core#11).
// A self-service tenant is only "Free" plus a machine key; the installer's
// label, the version and the last contact on its licence tell it apart.

export interface TenantLicence {
    uuid: string,
    edition: string,
    label: string,
    selfService: boolean,
    version: string,
    lastSeen: string | null,
    validUntil: string,
    currentTargets: number,
    numberOfTargets: number,
}

// "2026-10-24T18:16:12" -> "24.10.2026"; anything unreadable -> "".
export const day = (iso: string | null | undefined): string => {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso ?? "");
    return match ? `${match[3]}.${match[2]}.${match[1]}` : "";
};

// One line per licence, e.g.
// "Enterprise · Global Sec Hosting · 8.1172 · 1/50 targets · last contact 24.10.2026".
export const licenceLine = (licence: TenantLicence): string =>
    [
        licence.edition,
        licence.label || (licence.selfService ? "self-service, no label" : ""),
        licence.version,
        `${licence.currentTargets}/${licence.numberOfTargets} targets`,
        day(licence.lastSeen) ? `last contact ${day(licence.lastSeen)}` : "never in contact",
    ].filter(part => part !== "").join(" · ");
